import {
  GridOptions,
} from "@ag-grid-community/core";
import { AccountCellRendererComponent } from "src/app/ag-grid-components/account-cell-renderer/account-cell-renderer.component";

import { BooleanCellRendererComponent } from "src/app/ag-grid-components/boolean-cell-renderer/boolean-cell-renderer.component";
import { ChannelsCellRendererComponent } from "src/app/ag-grid-components/channels-cell-renderer/channels-cell-renderer.component";
import { CheckboxCellRendererComponent } from "src/app/ag-grid-components/checkbox-cell-renderer/checkbox-cell-renderer.component";
import { DateCellRendererComponent } from "src/app/ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { LinkCellRendererComponent } from "src/app/ag-grid-components/link-cell-renderer/link-cell-renderer.component";
import { LoadingCellRendererComponent } from "src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { OrderInfoCellRendererComponent } from "src/app/ag-grid-components/order-info-cell-renderer/order-info-cell-renderer.component";
import { OrderStatusCellRendererComponent } from "src/app/ag-grid-components/order-status-cell-renderer/order-status-cell-renderer.component";
import { ShipmentNameCellRendererComponent } from "src/app/ag-grid-components/shipment-name-cell-renderer/shipment-name-cell-renderer.component";
import { SkuCellRendererComponent } from "src/app/ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { StatusBarRendererComponent } from "src/app/ag-grid-components/status-bar-renderer/status-bar-renderer.component";
import { ActionsComponent } from "src/app/components/actions/actions.component";

import { HumanizeCamelCasePipe } from '../../../pipes/humanize-camel-case.pipe';
import { BuyBoxCellEditorComponent } from "src/app/ag-grid-components/buy-box--cell-editor/buy-box-cell-editor.component";
import { BuyBoxCellRendererComponent } from "src/app/ag-grid-components/buy-box-cell-renderer/buy-box-cell-renderer.component";
import { RankCellRendererComponent } from "src/app/ag-grid-components/rank-cell-renderer/rank-cell-renderer.component";

const humanizeCamelCasePipe = new HumanizeCamelCasePipe();
export const columnDefs: any = [
  {
    field: "VendorItemName",
    headerName: "Vendor Item",
    headerTooltip:"Vendor Item",
    backendFields: ["VendorItemName", "ImageUrl", "ItemVendorId", "ItemId", "VendorId", "ItemName"],
    cellRenderer: "skuCellRendererComponent",
    hide: false,
    cellRendererParams: (params) => {
      return {
        data: {
          Title: params.data.VendorItemName,
          Name: params.data.ItemName
        }
      }
    },
     filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "Vendor Item Name",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        {
          filter: "agTextColumnFilter",
          display: "accordion",
          title: "Item Name",
          filterParams: {
            defaultOption: "contains",
            maxNumConditions : 1,
          },
        },
      ],
    },
    width: 200,
  },
  {
    field: "VendorName",
    backendFields: ["VendorName"],
    headerName: "Vendor",
    width: 120,
    filter: 'agTextColumnFilter',
  },
  {
    field: "InboundStock",
    backendFields: ["InboundStock"],
    headerName: "Inbound",
    width: 120,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      return (Number(params.data.InboundStock) || 0).toLocaleString('en');
    },
  },  
  {
    field: "Price",
    backendFields: ["Price"],
    width: 120,
    filter: 'agNumberColumnFilter',
    valueFormatter: (param) =>
       "$" + (parseFloat(Number(param.value).toFixed(4))).toLocaleString('en')
  },
  {
    field: "AvgPrice",
    headerName: "Average Price",
    backendFields: ["AvgPrice"],
    filter: 'agNumberColumnFilter',
    width: 120,
    valueFormatter: (param) =>
    param.value?
       "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en'): "$" + 0.00
  },
  {
    field: "Notes",
    backendFields: ["Notes"],
    width: 120,
    filter: 'agTextColumnFilter',
  },
  {
    field: "CaseQty",
    backendFields: ["CaseQty"],
    width: 100,
    filter: 'agNumberColumnFilter',
    valueGetter: (params) => {
      return (Number(params.data.CaseQty) || 0).toLocaleString('en');
    },
  },
  {
    field: "CaseRoundingSetting",
    backendFields: ["CaseRoundingSetting"],
    headerName: "Enforce Case",
    width: 100,
    valueFormatter: (param) =>
    param.value ? humanizeCamelCasePipe.transform(param.value.toLowerCase()) : "",
    filter: 'agTextColumnFilter',
  },
  {
    field: "QtyPerVendorUnit",
    headerName:"Qty Per Vendor Unit",
    headerTooltip: "Qty Per Vendor Unit",
    backendFields: ["QtyPerVendorUnit"],
    width: 120,
    filter: 'agNumberColumnFilter',
  },
  {
    headerName: "Minimum Order Qty",
    field:"MinimumOrderQty",
    backendFields:["MinimumOrderQty"],
    width: 120
  },
  {
    field: "DeleteFlag",
    backendFields: ["DeleteFlag"],
    hide: true,
    filter: "booleanFilterComponent",
  },
];

const components = {
  booleanCellRendererComponent: BooleanCellRendererComponent,
  actionsComponent: ActionsComponent,
  skuCellRendererComponent: SkuCellRendererComponent,
  statusBarRendererComponent: StatusBarRendererComponent,
  loadingCellRenderer: LoadingCellRendererComponent,
  orderInfoCellRendererComponent: OrderInfoCellRendererComponent,
  channelsCellRendererComponent: ChannelsCellRendererComponent,
  orderStatusCellRendererComponent: OrderStatusCellRendererComponent,
  checkboxCellRendererComponent: CheckboxCellRendererComponent,
  dateCellRendererComponent: DateCellRendererComponent,
  linkCellRendererComponent: LinkCellRendererComponent,
  shipmentNameCellRendererComponent:ShipmentNameCellRendererComponent,
  accountCellRendererComponent:AccountCellRendererComponent,
  buyBoxCellEditorComponent: BuyBoxCellEditorComponent,
  buyBoxCellRendererComponent: BuyBoxCellRendererComponent,
  rankCellRendererComponent:RankCellRendererComponent

};

export const gridOptions: GridOptions = {
  rowModelType: "serverSide",
  suppressServerSideInfiniteScroll: false,
  suppressCopyRowsToClipboard: true,
  rowHeight: 42,
  maxConcurrentDatasourceRequests: 1,
  cacheBlockSize: 100,
  defaultColDef: {
    resizable: true,

    sortable: true,

    filterParams: {
      maxNumConditions : 1,
    },
    menuTabs: ["filterMenuTab"],
  },
  suppressMenuHide: true,
  components: components,

  statusBar: {
    statusPanels: [
      {
        statusPanel: "statusBarRendererComponent",
        align: "left",
        statusPanelParams: { model: false },
      },
    ],
  },
  loadingCellRenderer: "loadingCellRenderer",
  pivotPanelShow: "onlyWhenPivoting",
  rowBuffer: 50,
  enableCellChangeFlash: true,
  icons: {
    menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
    filter:
      '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
  },

};
